<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card elevation="0">
    <!-- <v-card-text>
      <v-card elevation="0">
        <list-search
          label="Kayıt arama"
          @list:searching="(keyword) => { $emit('con:search', keyword); }"
        >
        </list-search>
      </v-card>
    </v-card-text> -->
    <!-- FILTER -->
    <v-text-field
      @input="searching"
      prepend-inner-icon="mdi-magnify"
      label="Kişileri Filtrele"
      hide-details
      clearable
    ></v-text-field>
    <v-list
      shaped
      v-if="value.length"
    >
      <v-subheader>
        KİŞİLER
      </v-subheader>
      <v-flex xs12>
        <v-layout row>
          <!-- <v-btn
            text
            rounded
            depressed>
            <v-icon left>keyboard_arrow_right</v-icon>
            <span class="subtitle-1" v-text="header"></span>
          </v-btn> -->
          <v-spacer></v-spacer>
          <v-btn
            text
            depressed
            class="mr-4"
            @click="bulk"
          >
            Tümünü Seç
            <v-icon right>compare_arrows</v-icon>
          </v-btn>
        </v-layout>

      </v-flex>

      <v-list-item-group active-class="primary--text">
        <v-list-item
          v-for="(contact, i) in original"
          :key="i"
          @click="runFilter(contact)"
        >
          <v-list-item-icon>
            <v-icon>account_circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ contact.name }} {{ contact.surname }}
            </v-list-item-title>
            <v-list-item-subtitle v-text="contact.phone"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-avatar>
            <v-icon>compare_arrows</v-icon>
          </v-list-item-avatar>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-card-text v-else>
      <v-overlay
        absolute
        :value="loading"
        opacity="0"
        z-index="5"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-overlay>
      <div class="title font-weight-light grey--text pa-4 text-center">
        {{ noValueText }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// import ListSearch from './ListSearch.vue';

export default {
  name: 'ContactList',
  // components: { ListSearch },
  props: {
    loading: Boolean,
    value: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    noValueText: {
      type: String,
      default: 'Uygun Veri Yok',
    },
    itemValue: {
      type: String,
      default: 'name',
    },
    filter: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    // item: 1,
    menu: false,
    original: [],
  }),
  watch: {
    value(nv) {
      this.original = nv;
    },
  },
  events: {
    'con:filter-change': 'afterTreeChanged',
  },
  methods: {
    runFilter(obj) {
      this.original = this.original.filter(list => list !== obj);
      this.$emit('con:change', obj);
      this.$emit('con:length', this.original.length);
    },
    afterTreeChanged(e, v) {
      if (this.original.length <= 10) {
        this.original.push(v);
      }
    },
    bulk() {
      this.original.forEach((v) => {
        this.runFilter(v);
      });
      this.$emit('con:select-all', this.original);
    },
    searching(val) {
      this.data = this.items.filter(item => item.name.includes(val));
    },
  },
};
</script>
